<div class="page-wrapper" dir="ltr">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8 col-sm-12">

        <div class="page-header text-center">
          ENATIV Terms of Service
        </div>
        <p class="effective-date text-center">Effective Date: 21/04/2026</p>
        <p class="intro-text">
          These Terms of Service ("Terms") govern your use of ENATIV services.
        </p>

        <div class="terms-card">
          <ul class="terms-list">

            <li>
              <span class="section-title">1. Service Description</span>
              <p>ENATIV provides internet filtering, security, and authentication services, including SMS-based
                verification and account security notifications.</p>
            </li>

            <li>
              <span class="section-title">2. SMS Messaging Terms</span>
              <ul class="sub-list">
                <li>By providing your phone number and opting in, you agree to receive SMS messages from ENATIV for
                  authentication and account security purposes.</li>
                <li>Message frequency varies depending on user activity, such as login attempts or account-related
                  actions.</li>
                <li>Message and data rates may apply.</li>
                <li>You can opt out of SMS messages at any time by replying <strong>STOP</strong>. For assistance,
                  reply <strong>HELP</strong> or visit
                  <a href="https://www.enativ.com/contact" target="_blank">www.enativ.com/contact</a>.
                </li>
                <li>ENATIV does not send marketing or promotional SMS messages.</li>
                <li>Users must explicitly consent to receive SMS messages during registration.</li>
              </ul>
            </li>

            <li>
              <span class="section-title">3. User Responsibilities</span>
              <p>You agree to provide accurate information and use the service in accordance with applicable laws.</p>
            </li>

            <li>
              <span class="section-title">4. Privacy</span>
              <p>Your information is handled in accordance with our
                <a href="https://www.enativ.com/privacy-policy" target="_blank">Privacy Policy</a>.
              </p>
            </li>

            <li>
              <span class="section-title">5. Limitation of Liability</span>
              <p>ENATIV is not responsible for delayed or undelivered SMS messages.</p>
            </li>

            <li>
              <span class="section-title">6. Changes to Terms</span>
              <p>We may update these Terms from time to time. Continued use of the service constitutes acceptance of
                the updated Terms.</p>
            </li>

            <li>
              <span class="section-title">7. Contact</span>
              <p>For support, visit
                <a href="https://www.enativ.com/contact" target="_blank">www.enativ.com/contact</a>
                or contact our support team.
              </p>
            </li>

          </ul>
        </div>

      </div>
    </div>
  </div>
</div>
<div class="white-nav">
  <app-bottom-nav></app-bottom-nav>
</div>
